// Google Material Icon: account_balance (bank/payout)
export interface IIconProps {
	color?: string;
	size?: number;
}

export const IconAccountBalance = ({ color = "currentColor", size = 24 }: IIconProps) => {
	return (
		<svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M4 10h3v7H4zm6.5 0h3v7h-3zM2 19h20v3H2zm15-9h3v7h-3zm-5-9L2 6v2h20V6z"
				fill={color}
			/>
		</svg>
	);
};
